/* Go Damn - product page motion, MOBILE ONLY. No library, transform/opacity only. */
(function () {
  if (!window.matchMedia) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  document.documentElement.classList.add('gd-mm');

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        if (el.classList.contains('add-to-cart-button')) el.classList.add('gd-shine');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });
  }

  function watch(el) {
    if (!el || el.getAttribute('data-gdm-w')) return;
    el.setAttribute('data-gdm-w', '1');
    if (io) { io.observe(el); } else { el.classList.add('is-in'); }
  }

  function mark(el, kind, i) {
    if (!el || el.getAttribute('data-gdm')) return;
    el.setAttribute('data-gdm', kind);
    if (i) el.style.setProperty('--i', i);
    watch(el);
  }

  function split(el) {
    if (!el || el.getAttribute('data-gdm-split')) return;
    if (el.children.length) { watch(el); return; }
    var txt = (el.textContent || '').trim();
    if (!txt || txt.length > 120) { watch(el); return; }
    el.setAttribute('data-gdm-split', '1');
    var words = txt.split(/\s+/);
    var frag = document.createDocumentFragment();
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'gd-w';
      s.style.setProperty('--i', i);
      s.textContent = w;
      frag.appendChild(s);
      if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });
    el.textContent = '';
    el.appendChild(frag);
    watch(el);
  }

  function each(sel, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  function init() {
    var pd = document.querySelector('.product-details');
    if (pd) {
      split(pd.querySelector('h1'));

      var sub = Array.prototype.filter.call(
        pd.querySelectorAll('.gd-price__tax'),
        function (e) { return !e.closest('.gd-price-wrap'); }
      )[0];
      mark(sub, 'up', 1);

      mark(pd.querySelector('.jdgm-horizon-widget, .jdgm-preview-badge'), 'up', 2);
      mark(pd.querySelector('.gd-price-wrap'), 'up', 3);
      mark(pd.querySelector('.product-form-buttons'), 'up', 4);

      var trust = pd.querySelector('.gd-trust');
      if (trust) {
        each('.gd-trust__i', function (el, i) { el.style.setProperty('--i', i); }, trust);
        watch(trust);
      }

      mark(pd.querySelector('.gd-pin'), 'up', 1);
      watch(pd.querySelector('.add-to-cart-button'));
    }

    mark(document.querySelector('.gd-crumbs'), 'left', 0);
    mark(document.querySelector('media-gallery'), 'fade', 0);

    each('.gd-claims__i', function (el, i) { mark(el, 'left', i); });
    each('.gd-acc__i', function (el, i) { mark(el, 'up', i); });
    each('.cfy__card', function (el, i) { mark(el, 'rise', i % 2); });
    split(document.querySelector('.cfy__heading'));
  }

  /* safety net: anything already on screen that the observer missed is shown anyway */
  function rescue(all) {
    each('[data-gdm]:not(.is-in), [data-gdm-split]:not(.is-in), .gd-trust[data-gdm-w]:not(.is-in)', function (el) {
      if (all || el.getBoundingClientRect().top < window.innerHeight * 1.15) el.classList.add('is-in');
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', function () { setTimeout(function () { rescue(false); }, 1200); });
  setTimeout(function () { rescue(false); }, 3500);
  if (!io) setTimeout(function () { rescue(true); }, 1500);
})();
